import { useState } from "react";
import type { Page } from "../types";

export function Navbar({ onNavigate }: { onNavigate: (p: Page) => void }) {
    const [open, setOpen] = useState(false);

    const goHome = () => { onNavigate("home"); setOpen(false); };
    const goSection = (id: string) => {
        goHome();
        setTimeout(() => {
            const el = document.getElementById(id);
            if (el) {
                const top = el.getBoundingClientRect().top + window.scrollY - 88;
                window.scrollTo({ top, behavior: "smooth" });
            }
        }, 100);
    };

    const links = [
        { id: "avantages", label: "Avantages" },
        { id: "fonctionnalites", label: "Fonctionnalités" },
        { id: "apercu", label: "Aperçu" },
        { id: "tarif", label: "Tarif" },
        { id: "faq", label: "FAQ" },
    ];

    return (
        <>
            <nav className="fixed top-0 left-0 right-0 z-50 bg-white/92 backdrop-blur-xl border-b border-slate-200">
                <div className="max-w-[1200px] mx-auto px-6 flex items-center justify-between h-[72px]">
                    <button onClick={goHome} className="flex items-center gap-2.5 font-extrabold text-[1.4rem] text-slate-900 cursor-pointer bg-transparent border-none">
                        <img src="/resto_appli_logo.svg" alt="commander.appitep.fr" className="h-10" />
                        commander<span className="text-orange-500">.</span>appitep.fr
                    </button>

                    {/* Desktop links */}
                    <ul className="hidden md:flex items-center gap-8 list-none">
                        {links.map(l => (
                            <li key={l.id}>
                                <button onClick={() => goSection(l.id)} className="text-slate-500 font-medium text-[0.95rem] hover:text-slate-900 transition-colors cursor-pointer bg-transparent border-none">{l.label}</button>
                            </li>
                        ))}
                        <li>
                            <button onClick={() => { onNavigate("contact"); setOpen(false); }} className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full text-[0.9rem] font-bold bg-orange-500 text-white shadow-[0_4px_14px_rgba(249,115,22,0.35)] hover:bg-orange-600 hover:translate-y-[-2px] hover:shadow-[0_6px_20px_rgba(249,115,22,0.4)] transition-all cursor-pointer border-none">
                                Démarrer
                            </button>
                        </li>
                    </ul>

                    {/* Mobile burger */}
                    <button
                        className="md:hidden flex flex-col gap-[5px] p-2 bg-transparent border-none cursor-pointer"
                        onClick={() => setOpen(!open)}
                        aria-label="Menu"
                    >
                        <span className={`w-6 h-0.5 bg-slate-900 block transition-all ${open ? "rotate-45 translate-y-[7px]" : ""}`} />
                        <span className={`w-6 h-0.5 bg-slate-900 block transition-all ${open ? "opacity-0" : ""}`} />
                        <span className={`w-6 h-0.5 bg-slate-900 block transition-all ${open ? "-rotate-45 -translate-y-[7px]" : ""}`} />
                    </button>
                </div>
            </nav>

            {/* Mobile drawer backdrop */}
            <div
                className={`fixed inset-0 z-[60] md:hidden transition-opacity duration-300 ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
                onClick={() => setOpen(false)}
            >
                <div className="absolute inset-0 bg-black/40" />
            </div>

            {/* Mobile drawer panel */}
            <div
                className={`fixed top-0 right-0 z-[70] h-full w-72 bg-white shadow-xl md:hidden transition-transform duration-300 ease-in-out ${open ? "translate-x-0" : "translate-x-full"}`}
            >
                <div className="flex items-center justify-between px-6 h-[72px] border-b border-slate-200">
                    <span className="text-lg font-bold text-slate-900">Menu</span>
                    <button onClick={() => setOpen(false)} className="text-slate-500 hover:text-orange-500 bg-transparent border-none cursor-pointer" aria-label="Fermer">
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="flex flex-col px-6 py-4 gap-1">
                    {links.map(l => (
                        <button
                            key={l.id}
                            onClick={() => goSection(l.id)}
                            className="block w-full text-left py-3 text-slate-600 hover:text-orange-500 transition-colors cursor-pointer bg-transparent border-none border-b border-slate-100"
                        >
                            {l.label}
                        </button>
                    ))}
                    <a
                        href="https://appitep.fr"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setOpen(false)}
                        className="block w-full text-left py-3 text-slate-600 hover:text-orange-500 transition-colors cursor-pointer bg-transparent border-b border-slate-100 no-underline"
                    >
                        Qui sommes-nous ?
                    </a>
                    <button
                        onClick={() => { onNavigate("contact"); setOpen(false); }}
                        className="block w-full mt-4 text-center font-bold bg-orange-500 hover:bg-orange-600 text-white px-4 py-2.5 rounded-full transition-colors cursor-pointer border-none shadow-[0_4px_14px_rgba(249,115,22,0.35)]"
                    >
                        Démarrer
                    </button>
                </div>
            </div>
        </>
    );
}
